interface ContactField {
  label: string;
  value: string;
  icon: string;
  showCall?: boolean;
  showWhatsApp?: boolean;
  phone?: string;
}

interface CustomerInfoCardProps {
  fields: ContactField[];
  title?: string;
}

const cleanPhone = (phone: string) => (phone || '').replace(/\s/g, '');

export default function CustomerInfoCard({ fields, title = 'Müşteri Bilgileri' }: CustomerInfoCardProps) {
  const visibleFields = fields.filter(f => f.value);

  if (visibleFields.length === 0) {
    return null;
  }

  return (
    <>
      {/* Desktop: horizontal flex wrap */}
      <div className="hidden lg:flex bg-background-50 rounded-xl border border-background-200/70 p-5 flex-wrap gap-6">
        {visibleFields.map((field, i) => (
          <div key={i} className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0">
              <i className={`${field.icon} text-foreground-400`}></i>
            </span>
            <div>
              <p className="text-[11px] text-foreground-400 uppercase tracking-wider">{field.label}</p>
              <p className="text-sm font-medium text-foreground-800">{field.value}</p>
            </div>
            {field.showCall && field.phone && (
              <div className="flex items-center gap-1 ml-1">
                <a href={`tel:${cleanPhone(field.phone)}`} className="w-7 h-7 rounded-md bg-emerald-50 flex items-center justify-center cursor-pointer hover:bg-emerald-100 transition-colors" title="Ara">
                  <i className="ri-phone-line text-emerald-600 text-xs"></i>
                </a>
                <a href={`https://wa.me/90${cleanPhone(field.phone).slice(1)}`} target="_blank" rel="noopener noreferrer" className="w-7 h-7 rounded-md bg-emerald-50 flex items-center justify-center cursor-pointer hover:bg-emerald-100 transition-colors" title="WhatsApp">
                  <i className="ri-whatsapp-line text-emerald-600 text-xs"></i>
                </a>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Mobile: compact card */}
      <div className="lg:hidden bg-background-50 rounded-xl border border-background-200/70 p-4">
        <h3 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3">{title}</h3>
        <div className="space-y-3">
          {visibleFields.map((field, i) => (
            <div key={i} className="flex items-start justify-between gap-2">
              <div className="flex items-center gap-2 min-w-0 flex-1">
                <span className="w-7 h-7 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${field.icon} text-foreground-400 text-xs`}></i>
                </span>
                <div className="min-w-0">
                  <p className="text-[10px] text-foreground-400">{field.label}</p>
                  <p className="text-sm font-medium text-foreground-800 break-words">{field.value}</p>
                </div>
              </div>
              {field.showCall && field.phone && (
                <div className="flex items-center gap-1.5 flex-shrink-0">
                  <a
                    href={`tel:${cleanPhone(field.phone)}`}
                    className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center cursor-pointer hover:bg-emerald-100 active:scale-95 transition-all"
                    title="Ara"
                    style={{ minWidth: 44, minHeight: 44 }}
                  >
                    <i className="ri-phone-line text-emerald-600 text-sm"></i>
                  </a>
                  <a
                    href={`https://wa.me/90${cleanPhone(field.phone).slice(1)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center cursor-pointer hover:bg-emerald-100 active:scale-95 transition-all"
                    title="WhatsApp"
                    style={{ minWidth: 44, minHeight: 44 }}
                  >
                    <i className="ri-whatsapp-line text-emerald-600 text-sm"></i>
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}